import type { PopupBrandFont } from '@onetext/api';

export const brandFont : PopupBrandFont = {
    family: {
        primary:   'DM Sans',
        secondary: 'sans-serif'
    }
};
